module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4HRSZ"))).then(() => parcelRequire('ljYL6'));